// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/index.css';

import { Toast } from 'vant';



Vue.use(Vant);



Vue.config.productionTip = false

window.Toast = Toast;

/* eslint-disable no-new */
window.myApp = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    eventHub: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js